import { HeaderState } from './types';

const defaultHeaderState: HeaderState = {
  hasDivider: true,
  onSetHasDivider: () => {},
};

export { defaultHeaderState };
